export default __webpack_public_path__ + "5d0f19a77971fdb6319e1adf7979156b.png";